// Generated file : do not modify
export enum MandatTypes
{
  NONE = 0,
  B2B,
  B2C
};

export enum MandatStatuts
{
  NONE = 0,
  CREATED,
  SUBMITTED,
  SIGNED,
  USED,
  REVOQUED
};

export enum PaymentMeansTypes
{
  NONE = 0,
  RIB,
  CARTE_BANCAIRE,
  VIREMENT,
  UNUSED_CHEQUE
};

import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import Document from '@/extend/classes/Document';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Moyens de paiement
export class Mandat {
  // Type du mandat
  public type: MandatTypes;
  // Status du mandat
  public statut: MandatStatuts;
  // Date de soumission du mandat
  public submittedAt: Date | null;
  // Date de signature du mandat
  public signedAt: Date | null;
  // Date de révocation du mandat
  public revoquedAt: Date | null;

  constructor() {
    this.type = MandatTypes.NONE;
    this.statut = MandatStatuts.NONE;
    this.submittedAt = null;
    this.signedAt = null;
    this.revoquedAt = null;
  }
}

export default class PaymentMeans  {
  // Identifiant unique
  public id: number;
  // Type de paiement
  public type: PaymentMeansTypes;
  // 
  public typeId: number;
  // Mandat B2B
  public mandatB2b: Mandat;
  // Date de signature du mandat B2B (pour query)
  public b2bSignedAt: Date | null;
  // Mandat B2C
  public mandatB2c: Mandat;
  // Date de signature du mandat B2C (pour query)
  public b2cSignedAt: Date | null;
  // 
  public label: string;
  // Owner
  public owner: Owner;
  // Mode de prélèvement forcé (0 : NONE, 1 : B2B, 2 : B2C)
  public forcedMode: MandatTypes;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.type = PaymentMeansTypes.NONE;
    this.typeId = 0;
    this.mandatB2b = new Mandat();
    this.b2bSignedAt = null;
    this.mandatB2c = new Mandat();
    this.b2cSignedAt = null;
    this.label = '';
    this.owner = new Owner();
    this.forcedMode = MandatTypes.NONE;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: PaymentMeans): PaymentMeans {
    const newPaymentMeans: PaymentMeans = new PaymentMeans();
    newPaymentMeans.id = obj.id;
    newPaymentMeans.type = obj.type;
    newPaymentMeans.typeId = obj.typeId;
    newPaymentMeans.mandatB2b = JSON.parse(JSON.stringify(obj.mandatB2b));
    newPaymentMeans.b2bSignedAt = obj.b2bSignedAt ? new Date(obj.b2bSignedAt) : null;
    newPaymentMeans.mandatB2c = JSON.parse(JSON.stringify(obj.mandatB2c));
    newPaymentMeans.b2cSignedAt = obj.b2cSignedAt ? new Date(obj.b2cSignedAt) : null;
    newPaymentMeans.label = obj.label;
    newPaymentMeans.owner = JSON.parse(JSON.stringify(obj.owner));
    newPaymentMeans.forcedMode = obj.forcedMode;
    newPaymentMeans.createId = obj.createId;
    newPaymentMeans.failed = obj.failed;
    newPaymentMeans.canUpdate = obj.canUpdate;
    newPaymentMeans.canDelete = obj.canDelete;
    newPaymentMeans.display = obj.display;
    newPaymentMeans.notifDefType = obj.notifDefType;
    newPaymentMeans.ownerType = obj.ownerType;
    newPaymentMeans.ownerId = obj.ownerId;
    newPaymentMeans.ownerLabel = obj.ownerLabel;
    return newPaymentMeans;
  }

  public toJsonPaymentMeans (): string {
    const json = {
      type: this.type,
      typeId: this.typeId,
      mandatB2b: this.mandatB2b,
      b2bSignedAt: this.b2bSignedAt ? new Date (this.b2bSignedAt).toString() : this.b2bSignedAt,
      mandatB2c: this.mandatB2c,
      b2cSignedAt: this.b2cSignedAt ? new Date (this.b2cSignedAt).toString() : this.b2cSignedAt,
      label: this.label,
      owner: this.owner,
      forcedMode: this.forcedMode,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromPaymentMeans (obj: PaymentMeans): void {
    this.id = obj.id;
    this.type = obj.type;
    this.typeId = obj.typeId;
    this.mandatB2b = obj.mandatB2b;
    this.b2bSignedAt = obj.b2bSignedAt;
    this.mandatB2c = obj.mandatB2c;
    this.b2cSignedAt = obj.b2cSignedAt;
    this.label = obj.label;
    this.owner = obj.owner;
    this.forcedMode = obj.forcedMode;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public comparePaymentMeans (value: PaymentMeans): boolean {
    return (this.toJsonPaymentMeans() == value.toJsonPaymentMeans());
  }

  public clonePaymentMeans (): PaymentMeans {
    return PaymentMeans.fromJson(this);
  }

  public createForStorePaymentMeans (): Promise<PaymentMeans> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paymentmeans/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromPaymentMeans(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStorePaymentMeans (): Promise<PaymentMeans> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/paymentmeans/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromPaymentMeans(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStorePaymentMeans (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/paymentmeans/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paymentmeans/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static signMandat (document: Document): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/paymentmeans/signMandat', document, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/PaymentMeans/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = PaymentMeans.fromJson(listData.reccords[0] as PaymentMeans);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<PaymentMeans> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/PaymentMeans/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = PaymentMeans.fromJson(listData.reccords[0] as PaymentMeans);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(paymentMeanss: PaymentMeans[]) {
    paymentMeanss.forEach((item) => {
      item.b2bSignedAt = item.b2bSignedAt ? new Date(item.b2bSignedAt) : item.b2bSignedAt;
      item.b2cSignedAt = item.b2cSignedAt ? new Date(item.b2cSignedAt) : item.b2cSignedAt;
    })
  }
}
